import { addStaticSplideClasses, callAfterResize, connectSplideBullets, isSafari, pauseVideos, sel, selAll, splideAutoWidth } from './utils'
// import Splide from '@splidejs/splide'
// import '@splidejs/splide/css'

export default function SignupVideo() {
  const video$a = selAll('.signup__slider__slide')
  // randomly select one, remove others
  const randomIndex = Math.floor(Math.random() * video$a.length)
  video$a.forEach((video$, index) => {
    if (index !== randomIndex) {
      video$.remove()
    }
  })
  const slide$ = sel('.testimonial-slider__item__c')
  isSafari && slide$.style.setProperty('--blur', '0px')
}
